module.exports = __webpack_public_path__ + "img/icon-trash.07839fe4.svg";